import {ApiEndpointBuilder} from 'services/api/types';
import {ResponseData} from 'types/response-data';
import {User} from 'types/user';

const toggleNotificationsEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<ResponseData<User>, boolean>({
    query: onOrOff => ({
      url: 'me/profile/notifications',
      method: 'PUT',
      body: {
        status: onOrOff,
      },
    }),
  });
};

export default toggleNotificationsEndpoint;
